const CUSTOM_ALIAS_ICON_BRANDS = [ "zapyrus" ];

export const aliasSearchIcon = (brand) => {
  if(CUSTOM_ALIAS_ICON_BRANDS.includes(brand)) {
    return `${brand}-branded`;
  } else {
    return "star";
  }
}
